import { UsersState } from '@/types/state/users';
import { userConstants } from '../constants';

const initialState: UsersState = {
  hasFetched: false,
};

export function users(state = initialState, action): UsersState {
  switch (action.type) {
    case userConstants.UPDATE_USER_SUCCESS:
    case userConstants.LOGIN_SUCCESS:
      return {
        user: action.user,
        hasFetched: state.hasFetched,
      };
    case userConstants.LOGOUT:
      return {
        loggedOut: true,
        hasFetched: state.hasFetched,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        errorLogin: action.error,
        hasFetched: state.hasFetched,
      };
    case userConstants.DELETE_USER:
      return {
        userDeleted: true,
        hasFetched: state.hasFetched,
      };
    case userConstants.FETCHED_USER:
      return {
        ...state,
        hasFetched: true,
      };
    default:
      return state;
  }
}
